module.exports = __webpack_public_path__ + "img/rectangle-4.a280114e.svg";